import { tagColors } from "@/components/tag/tag-colors";
// common
export const stateOption = [
    {id: 1, text: '是'},
    {id: 0, text: '否'},
];

export const stateOptionBoolean = [
    {id: true, text: '是'},
    {id: false, text: '否'},
];

export const currencysOption = [
    {id: 'USD', text: '$'}, // 美国
    {id: 'JPY', text: 'J￥'}, // 日本
    {id: 'CAD', text: 'CA$'}, // 加拿大
    {id: 'GBP', text: '￡'}, // 英镑
    {id: 'EUR', text: '€'}, // 欧元
    {id: 'AUD', text: 'AU$'}, // 澳元
    {id: 'BRL', text: 'R$'}, // 巴西雷亚尔
    {id: 'INR', text: '₹'}, // 印度
    {id: 'CNY', text: '￥'}, // 人名币
    {id: 'MXN', text: 'MX$'}, // 墨西哥
    {id: 'HKD', text: 'HK$'}, // 香港
    {id: 'AED', text: 'د.إ'}, // 阿联酋
    // {id: 'ANG', text: 'ƒ'}, // 荷兰
    // {id: 'SEK', text: 'kr'}, // 瑞典
    // {id: 'TRY', text: '₺'}, // 土耳其
];

export const dashboardCurrencysOption = [
    {id: 'USD', text: '$'}, // 美国
    {id: 'JPY', text: 'J￥'}, // 日本
    {id: 'CAD', text: 'CA$'}, // 加拿大
    {id: 'GBP', text: '￡'}, // 英镑
    {id: 'EUR', text: '€'}, // 欧元
    {id: 'AUD', text: 'AU$'}, // 澳元
    {id: 'BRL', text: 'R$'}, // 巴西雷亚尔
    {id: 'INR', text: '₹'}, // 印度
    {id: 'CNY', text: '￥'}, // 人名币
    {id: 'MXN', text: 'MX$'}, // 墨西哥
    {id: 'HKD', text: 'HK$'}, // 香港
    {id: 'AED', text: 'د.إ'}, // 阿联酋
    {id: 'ANG', text: 'ƒ'}, // 荷兰
    {id: 'SEK', text: 'kr'}, // 瑞典
    {id: 'TRY', text: '₺'}, // 土耳其
];

export const financeCurrencysOption = [
    {id: '', text: '原币种'}, // 美国
    {id: 'USD', text: 'USD'}, // 美国
    {id: 'JPY', text: 'JPY'}, // 日本
    {id: 'CAD', text: 'CAD'}, // 加拿大
    {id: 'GBP', text: 'GBP'}, // 英镑
    {id: 'EUR', text: 'EUR'}, // 欧元
    {id: 'AUD', text: 'AUD'}, // 澳元
    {id: 'BRL', text: 'BRL'}, // 巴西雷亚尔
    {id: 'INR', text: 'INR'}, // 印度
    {id: 'CNY', text: 'CNY'}, // 人名币
    {id: 'MXN', text: 'MXN'}, // 墨西哥
    {id: 'HKD', text: 'HKD'}, // 香港
    {id: 'AED', text: 'AED'}, // 阿联酋
    {id: 'SAR', text: 'SAR'}, //
    {id: 'TRY', text: 'TRY'}, //
];

export const disableOption = [
    {id: 1, text: '启用'},
    {id: 0, text: '停用'},
];

export const disableLowerCaseOption = [
    {id: 'enable', text: '启用',...tagColors.greenText},
    {id: 'disable', text: '停用', ...tagColors.gray9Text},
];

// 用户管理:用户状态
export const userDisableOption = [
    {id: 'ENABLE', text: '启用'},
    {id: 'DISABLE', text: '停用'},
];
// 跟卖监控:监控状态
export const followDisableOption = [
    {id: 'Active', text: '启用'},
    {id: 'Inactive', text: '停用'},
];
// 充值记录状态
export const recordPayStatus = [
    {id: 'SUCCESS', text: '成功'},
    {id: 'FAIL', text: '失败'},
    {id: 'AUDIT', text: '待审核'},
];

export const shippingType = [
    {id: 'AFN', text: '亚马逊配送'},
    {id: 'MFN', text: '卖家自配送'},
];

export const amazonCountryOption = [
    {id: 'US', text: '美国'},
    {id: 'UK', text: '英国'},
    {id: 'CA', text: '加拿大'},
    {id: 'MX', text: '墨西哥'},
    {id: 'AU', text: '澳大利亚'},
    {id: 'JP', text: '日本'},
    {id: 'DE', text: '德国'},
    {id: 'ES', text: '西班牙'},
    {id: 'FR', text: '法国'},
    {id: 'GB', text: '英国'},
    {id: 'IT', text: '意大利'},
    {id: 'IN', text: '印度'},
    {id: 'AE', text: '阿联酋'},
    {id: 'NL', text: '荷兰'},
    {id: 'BR', text: '巴西'},
    {id: 'TR', text: '土耳其'},
    {id: 'SA', text: '沙特阿拉伯'},
    {id: 'SG', text: '新加坡'},
    {id: 'SE', text: '瑞典'},
    {id: 'PL', text: '波兰'},
];

export const paperLabelOption = [
    {id: 11, text: '热敏纸(50*30)单排'},
    {id: 12, text: '热敏纸(100*30)双排'},
    {id: 0, text: '每张 US 信纸最多 30 个标签（1 英寸 x 2-5/8 英寸）'},
    {id: 1, text: '每页纸最多 21 个标签（A4 纸，63.5 毫米 x 38.1 毫米）'},
    {id: 2, text: '每页纸最多 24 个标签（A4 纸，63.5 毫米 x 33.9 毫米）'},
    {id: 3, text: '每页纸最多 24 个标签（A4 纸，64.6 毫米 x 33.8 毫米）'},
    {id: 4, text: '每页纸最多 24 个标签（A4 纸，66 毫米 x 33.9 毫米）'},
    {id: 5, text: '每页纸最多 24 个标签（A4 纸，66 毫米 x 35 毫米）'},
    {id: 6, text: '每页纸最多 24 个标签（A4 纸，70 毫米 x 36 毫米）'},
    {id: 7, text: '每页纸最多 24 个标签（A4 纸，70 毫米 x 37 毫米）'},
    {id: 8, text: '每页纸最多 27 个标签（A4 纸，63.5 毫米 x 29.6 毫米）'},
    {id: 9, text: '每页纸最多 40 个标签（A4 纸，52.5 毫米 x 29.7 毫米）'},
    {id: 10, text: '每页纸最多 44 个标签（A4 纸，48.5 毫米 x 25.4 毫米）'},
];

// listing
export const listingLevelOption = [
    {id: 0, text: '战略'},
    {id: 1, text: '主推'},
    {id: 2, text: '一般'},
    {id: 3, text: '长尾'},
    {id: 4, text: '短期'},
];

export const listingStateOption = [
    {id: 0, text: '新品'},
    {id: 1, text: '维护'},
    {id: 2, text: '清货'},
    {id: 3, text: '废弃'}
];

// review
export const reviewStarOption = [
    {id: 1, text: '一星'},
    {id: 2, text: '二星'},
    {id: 3, text: '三星'},
    {id: 4, text: '四星'},
    {id: 5, text: '五星'},
];

export const reviewStatusOption = [
    {id: 'Pending', text: '待处理'},
    {id: 'Processing', text: '处理中'},
    {id: 'Done', text: '已完成'},
];

export const trackingResultsOption = [
    {id: 'deleted', text: '已删除'},
    {id: 'unEmailReply', text: '无变化-邮件不回复'},
    {id: 'unCustomerAgree', text: '无变化-客户不同意'},
    {id: 'higher', text: '分数变化-调高'},
    {id: 'lower', text: '分数变化-调低'},
    {id: 'nothing', text: '无'},
];

export const reviewTypeOption = [
    {id: 'reviewDate', text: '评论日期'},
    {id: 'updateTime', text: '更新时间'},
    {id: 'createTime', text: '记录时间'},
];

export const reviewDynamicKeyOption =[
    {id: 'asinList', text: 'ASIN', moreShow: true},
    {id: 'orderId', text: '订单号'},
    {id: 'amazonUserName', text: '评论用户'},
    // {id: 'reviewId', text: '评论编号'},
    {id: 'reviewCode', text: '评论编号'},
];

// 用户管理
export const userDynamicKeyOption = [
    {id: 'name', text: '真实姓名'},
    {id: 'userName', text: '用户名'},
    {id: 'phone', text: '手机号码'},
];
// 销售订单
export const saleOrderStatus = [
    { id: 'Pending', text: '未付款', ...tagColors.red},
    { id: 'Unshipped', text: '未发货', ...tagColors.orange},
    { id: 'PartiallyShipped', text: '拣货中', ...tagColors.blue},
    {id: 'Shipped', text: '已发货', ...tagColors.green},
    { id: 'Canceled', text: '已取消', ...tagColors.lightGray},
    {id: 'Unfulfillable', text: '预定订单', ...tagColors.violet},
    {id: 'InvoiceUnconfirmed', text: '部分发货', ...tagColors.green},
    { id: 'PendingAvailability', text: '无状态', ...tagColors.lightGray},
];

export const pathCountry = [
    {id: 'US', text: '美国-US'},
    {id: 'CA', text: '加拿大-CA'},
    {id: 'MX', text: '墨西哥-MX'},
    {id: 'AU', text: '澳大利亚-AU'},
    {id: 'JP', text: '日本-JP'},
    {id: 'DE', text: '德国-DE'},
    {id: 'ES', text: '西班牙-ES'},
    {id: 'FR', text: '法国-FR'},
    {id: 'GB', text: '英国-GB'},
    {id: 'IT', text: '意大利-IT'},
    {id: 'IN', text: '印度-IN'},
    {id: 'AE', text: '阿拉伯联合酋长国-AE'},
    {id: 'NL', text: '荷兰-NL'},
    {id: 'BE', text: '比利时-BE'},
    {id: 'CH', text: '瑞士-CH'},
    {id: 'NO', text: '挪威-NO'},
    {id: 'SE', text: '瑞典-SE'},
    {id: 'PT', text: '葡萄牙-PT'},
    {id: 'IE', text: '爱尔兰-IE'},
    {id: 'EG', text: '埃及-EG'},
    {id: 'SA', text: '沙特阿拉伯-SA'},
    {id: 'TR', text: '土耳其-TR'},
    {id: 'SG', text: '新加坡-SG'},
    {id: 'BR', text: '巴西-BR'},
    {id: 'LU', text: '卢森堡-LU'},
    {id: 'GR', text: '希腊-GR'},
    {id: 'AT', text: '奥地利-AT'},
    {id: 'PL', text: '波兰-PL'},
];

export const saleOrderDynKey1 = [
    {id: 'orderId', text: '订单编号', moreShow: true},
    {id: 'sellerOrderId', text: '卖家订单编号',},
    {id: 'buyerName', text: '买家姓名',},
    {id: 'buyerEmail', text: '买家邮箱',},
    {id: 'quantityOrdered', text: '订购数量',},
    {id: 'promotionId', text: '促销编码',}
];

export const saleOrderDynKey2 = [
    {id: 'asin', text: 'ASIN', moreShow: true},
    {id: 'sku', text: 'SKU',},
    {id: 'msku', text: 'MSKU',}
];

export const saleOrderDynKey3 = [
    {id: 'asin', text: 'ASIN',},
    {id: 'msku', text: 'MSKU',}
];

export const saleOrderType = [
    {id: 'StandardOrder', text: '标准订单'},
    {id: 'Multichannel', text: '多渠道订单'},
    {id: 'ReplacementOrder', text: '换货订单'},
    {id: 'B2BOrder', text: 'B2B订单'},
    {id: 'TestOrder', text: '推广订单'},
    {id: 'PromotionOrder', text: '促销订单'},
    {id: 'VineOrder', text: 'VINE订单'},
];
// 发票类型
export const invoiceTypesOptions = [
    {id: 'invoice', text: '发票'},
    {id: 'creditNote', text: '贷记单'},
    {id: 'receipt', text: '收据'}
]
// 发票上传状态
export const invoiceUploadStatusOptions = [
    {id: 'wait', text: '待上传'},
    {id: 'uploading', text: '上传中'},
    {id: 'success', text: '上传成功'},
    {id: 'fail', text: '上传失败'},
    {id: 'uploaded', text: '亚马逊已上传'}
]

export const saleRequestReviewStatusOption = [
    {id: 'NoRequest', text: '未请求'},
    {id: 'Fail', text: '请求失败'},
    {id: 'Success', text: '请求成功'}
]

// 发送规则
export const sendRuleStatus = [
    {id: 'Active', text: '启用'},
    {id: 'Inactive', text: '禁用'},
    {id: 'Close', text: '归档'},
];

export const sendRuleShippingRules = [
    {id: 0, text: '订单订购后'},
    // {id: 1, text: '订单发货后'},
    // {id: 2, text: '订单送达后'},
];

// 发送记录
export const sendRecordResult = [
    {id: 'NoRequest', text: '未请求'},
    {id: 'Fail', text: '请求失败'},
    {id: 'Success', text: '请求成功'},
    {id: 'AlreadyRequest', text: '请求前已成功请求'},
    {id: 'OrderRefunded', text: '订单已退款'},
    {id: 'OrderReturned', text: '订单已退货'},
    {id: 'ContainPromotionDiscount', text: '订单商品有促销折扣'},
    {id: 'ContainShippingDiscount', text: '订单商品有运费折扣'},
    {id: 'PromotionOrder', text: '订单是推广订单'},
    {id: 'OutsideRange', text: '未在允许时间范围内'},
];

// 财务利润报表
export const financeProfitReportCurrency = [
    {id: '', text: '原币种'},
    {id: 'USD', text: 'USD'},
    {id: 'CNY', text: 'CNY'},
];

export const sharingStatus = [
    {id: 0, text: '未分摊'},
    {id: 1, text: '已分摊'},
];

export const sharingRule = [
    {id: 0, text: '天数分摊'},
    {id: 1, text: '销量分摊'},
    {id: 2, text: '销售额分摊'},
];

export const settlementReportType = [
    {id: 1, text: '标准订单'},
    {id: 2, text: '发票订单'},
    {id: 3, text: '所有订单'},
];

export const orderTypeOption = [
    {id: 1, text: 'Standard'},
    {id: 2, text: 'Invoiced'},
    {id: 3, text: 'All'},
];

// 统计分析
export const statisticsCurrency = [
    {id: '', text: '原币种'},
    {id: 'USD', text: 'USD'},
    {id: 'CNY', text: 'CNY'},
];

export const timezoneOption = [
    {id: 'DATE', text: '市场时间'},
    {id: 'PST', text: 'PST(太平洋时间)'},
    {id: 'GMT', text: 'GMT(格林时间)'},
    {id: 'CEST', text: 'CEST(中欧时间)'},
    {id: 'JST', text: 'JST(日本时间)'},
    {id: 'AEST', text: 'AEST(澳大利亚时间)'},
    {id: 'BeiJing', text: 'CCT(北京时间)'},
];

export const countryOption = [
    {id: 'CN', text: '中国', timezone: 'BeiJing', icon:'iconzhongguo-'},
    {id: 'US', text: '美国', timezone: 'PST', icon:'iconmeiguo-'},
    {id: 'UK', text: '英国', timezone: 'GMT', icon:'iconyingguo-'},
    {id: 'GB', text: '英国', timezone: 'GMT', icon:'iconyingguo-'},
    {id: 'CA', text: '加拿大', timezone: 'PST', icon:'iconjianada-'},
    {id: 'MX', text: '墨西哥', timezone: 'PST', icon:'iconmoxige'},
    {id: 'AU', text: '澳大利亚', timezone: 'AEST', icon:'iconaodaliya-'},
    {id: 'JP', text: '日本', timezone: 'JST', icon:'iconriben'},
    {id: 'DE', text: '德国', timezone: 'CEST', icon:'icondeguo1'},
    {id: 'ES', text: '西班牙', timezone: 'CEST', icon:'iconxiaoshou-'},
    {id: 'FR', text: '法国', timezone: 'CEST', icon:'iconfaguoqi'},
    {id: 'IT', text: '意大利', timezone: 'CEST', icon:'iconyidali'},
    {id: 'IN', text: '印度', timezone: 'CEST', icon:'iconyindu'},
    {id: 'AE', text: '阿联酋', timezone: 'CEST', icon:'iconalabolianheqiuchangguo'},
    {id: 'NL', text: '荷兰', timezone: 'CEST', icon:'iconhelan'},
    {id: 'BE', text: '比利时', timezone: '', icon:''},
    {id: 'CH', text: '瑞士', timezone: '', icon:''},
    {id: 'NO', text: '挪威', timezone: '', icon:''},
    {id: 'SE', text: '瑞典', timezone: '', icon:'iconruidian'},
    {id: 'PT', text: '葡萄牙', timezone: '', icon:''},
    {id: 'IE', text: '爱尔兰', timezone: '', icon:''},
    {id: 'EG', text: '埃及', timezone: '', icon:''},
    {id: 'SA', text: '沙特阿拉伯', timezone: 'CEST', icon:'iconshatealabo'},
    {id: 'TR', text: '土耳其', timezone: 'CEST', icon:'icontuerqi'},
    {id: 'SG', text: '新加坡', timezone: 'BeiJing', icon:'iconicon_SGxinjiapo'},
    {id: 'BR', text: '巴西', timezone: 'PST', icon:'iconbaxi'},
    {id: 'LU', text: '卢森堡', timezone: '', icon:''},
    {id: 'GR', text: '希腊', timezone: '', icon:''},
    {id: 'AT', text: '奥地利', timezone: '', icon:''},
    {id: 'PL', text: '波兰', timezone: '', icon:''},
];

export const ProductEnum = {
    type: {
        PRODUCT: 'Product',
        ASSEMBLY: 'Assembly'
    },
    typeOption: [
        {id: 'Product', text: '普通产品'},
        {id: 'Assembly', text: '组合产品'},
    ],
    status: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
    },
    statusOption: [
        {id: 'Active', text: '启用',...tagColors.greenText},
        {id: 'Inactive', text: '停用', ...tagColors.gray9Text},
    ],
    logTypeOption: [
        {id: 'Enable', text: '启用'},
        {id: 'Disable', text: '停用'},
        {id: 'Add', text: '添加'},
        {id: 'Delete', text: '删除'},
        {id: 'Update', text: '更新'},
        {id: 'ImportAdd', text: '导入新增'},
        {id: 'ImportUpdate', text: '导入更新'},
    ]
};

export const OpEnum = {
    type: {
        ADD: 0,
        UPDATE: 1,
        COPY: 2,
        VIEW: 3,
        USE: 4,
    },
    typeOption: [
        {id: 0, text: '添加'},
        {id: 1, text: '编辑'},
        {id: 2, text: '复制'},
        {id: 3, text: '查看'},
    ]
};

// listing
export const listingStatus = [
    {id: 'Active', text: '在售'},
    {id: 'InActive', text: '停售'},
    {id: 'InComplete', text: '不完整'},
    {id: 'Delete', text: '删除'},
];
export const listingStatustwo = [
    {id: 'Active', text: '在售'},
    {id: 'Inactive', text: '停售'},
    {id: 'Incomplete', text: '不完整'},
    {id: 'Delete', text: '删除'},
];
// delivery-plan
export const deliveryPlanStatus=[
    {id: 'processing', text: '进行中', color: '#1F6EEF'},
    {id: 'draft', text: '草稿', color: '#3C4869'},
    {id: 'waitReview', text: '待审核', color: '#F98F04'},
    {id: 'rejected', text: '已驳回', color: '#E94747'},
    {id: 'waitHandle', text: '待处理', color: '#F98F04'},
    {id: 'processed', text: '已处理', color: '#CCCCCC'},
    {id: 'abolished', text: '已作废', color: '#E7EAEF'},
]

export const listingOperationStatus = [
    {id: 'ClearStocks', text: '清货'},
    {id: 'New', text: '新品期'},
    {id: 'HotSale', text: '爆品期'},
    {id: 'Stable', text: '稳定期'},
    {id: 'Replenishment', text: '暂停补货'},
];


// 供应商
export const settlementType = [
    {id: 'cash', text: '现结'},
    {id: 'monthly', text: '月结'}
];

//全店铺运营分析
export const comparisonMethodOptions = [
    {id: 0, text: '时间对比'},
    {id: 1, text: '指标对比'}
]
// 指标对比列表
export const indexComparisonOptions = [
    {id: "unitsOrdered", text: '销量'},
    {id: "unitsOrderedB2b", text: '销量-B2B'},
    {id: "orderProductSales", text: '销售额'},
    {id: "orderProductSalesB2b", text: '销售额-B2B'},
    {id: "orders", text: '订单量'},
    {id: "refunds", text: '退款量'},
    {id: "refundsRate", text: '退款率'},
    {id: "returnProductSales", text: '退款销售额'},
    {id: "returns", text: '退货量'},
    {id: "returnsRate", text: '退货率'},
    // {id: "avgOrderItems", text: '平均订单商品种类数'},
    {id: "avgUnitsOrderedSales", text: '平均订单价格'},
    {id:'sessionsMobile',text:'Sessions-移动端'},
    {id:'sessionsBrowser',text:'Sessions-PC端'},
    {id:'sessions',text:'Sessions-总计'},
    {id:'unitSessionPercentage',text:'CVR'},
    {id:'pageViewsMobile',text:'PV-移动端'},
    {id:'pageViewsBrowser',text:'PV-PC端'},
    {id:'pageViews',text:'PV-总计'},
    {id:'buyBoxPercentage',text:'Buybox'},
    {id:'mainCategoryRank',text:'大类排名'},
    {id:'subCategoryRank',text:'小类排名'},
    {id: "totalIncome", text: '总收入'},
    {id: "totalExpenditure", text: '总支出'},
    {id: "salesGrossProfit", text: '销售毛利'},
    {id: "grossProfitRate", text: '销售毛利率'},
    {id: "salesNetProfit", text: '销售净毛利'},
    {id: "salesNetProfitRate", text: '销售净毛利率'},
    {id: "adsImpressions", text: '广告曝光量'},
    {id: "adsClicks", text: '广告点击量'},
    {id: "ctr", text: 'CTR'},
    {id: "adsOrders", text: '广告订单量'},
    {id: "adsSales", text: '广告销售额'},
    {id: "cr", text: '广告CVR'},
    {id: "adsSpend", text: '广告花费'},
    {id: "cpc", text: 'CPC'},
    {id: "acoS", text: 'ACOS'},
    {id: "roAS", text: 'ROAS'},
    {id: "asoAS", text: 'ASOAS'},
    {id: "acoAS", text: 'ACOAS'},
    {id: "midBadReview", text: "Review中差评"},
    {id:'star',text:'评分'}
];
export const comparisonOptionsOthers = [
    {id: "unitsOrdered", text: '销量'},
    {id: "unitsOrderedB2b", text: '销量-B2B'},
    {id: "orderProductSales", text: '销售额'},
    {id: "orderProductSalesB2b", text: '销售额-B2B'},
    {id: "orders", text: '订单量'},
    {id: "refunds", text: '退款量'},
    {id: "refundsRate", text: '退款率'},
    {id: "returnProductSales", text: '退款销售额'},
    {id: "returns", text: '退货量'},
    {id: "returnsRate", text: '退货率'},
    // {id: "avgOrderItems", text: '平均订单商品种类数'},
    {id: "avgUnitsOrderedSales", text: '平均订单价格'},

    {id:'sessionsMobile',text:'Sessions-移动端'},
    {id:'sessionsBrowser',text:'Sessions-PC端'},
    {id:'sessions',text:'Sessions-总计'},
    {id:'unitSessionPercentage',text:'CVR'},
    {id:'pageViewsMobile',text:'PV-移动端'},
    {id:'pageViewsBrowser',text:'PV-PC端'},
    {id:'pageViews',text:'PV-总计'},
    {id:'buyBoxPercentage',text:'Buybox'},

    {id: "totalIncome", text: '总收入'},
    {id: "totalExpenditure", text: '总支出'},
    {id: "salesGrossProfit", text: '销售毛利'},
    {id: "grossProfitRate", text: '销售毛利率'},
    {id: "salesNetProfit", text: '销售净毛利'},
    {id: "salesNetProfitRate", text: '销售净毛利率'},
    {id: "adsImpressions", text: '广告曝光量'},
    {id: "adsClicks", text: '广告点击量'},
    {id: "ctr", text: 'CTR'},
    {id: "adsOrders", text: '广告订单量'},
    {id: "adsSales", text: '广告销售额'},
    {id: "cr", text: '广告CVR'},
    {id: "adsSpend", text: '广告花费'},
    {id: "cpc", text: 'CPC'},
    {id: "acoS", text: 'ACOS'},
    {id: "roAS", text: 'ROAS'},
    {id: "asoAS", text: 'ASOAS'},
    {id: "acoAS", text: 'ACOAS'},

    {id: "midBadReview", text: "Review中差评"},
    {id:'midBadFeedback',text:'Feedback中差评'}
];
//订单类型
export const orderTypeOptions = [
    {id: "ALL", text: '全部订单'},
    {id: "PROMOTION", text: '促销订单'}
];

//时间区间
export const timeRangeOptions = [
    {id: 0, text: '今天'},
    {id: 1, text: '昨天'},
    {id: 2, text: '近7天'},
    {id: 3, text: '近14天'},
    {id: 4, text: '近30天'},
    {id: 5, text: '近60天'},
    {id: 6, text: '本周'},
    {id: 7, text: '本月'},
    {id: 8, text: '本年至今'},
];

//时间区间
export const timeRangeOptionsEx = [
    {id: 0, text: '今天'},
    {id: 1, text: '昨天'},
    {id: 2, text: '近7天'},
    {id: 3, text: '近14天'},
    {id: 4, text: '近30天'},
    {id: 5, text: '近60天'},
    {id: 6, text: '本周'},
    {id: 7, text: '本月'},
    {id: 8, text: '本年至今'},
];

export const monthRangeOptions = [
    {id: 0, text: '本月'},
    {id: 1, text: '上月'},
    {id: 2, text: '近3月'},
    {id: 3, text: '近6月'},
    {id: 4, text: '本年至今'},
];

export const DATE_TYPE_OPTIONS = [
    { id: 'DAY', text: '日期' },
    { id: 'MONTH', text: '月份' }
];

//
export const AD_LINE_OPTIONS  = [
    { id: 'impressions', 'text': '曝光量' },
    { id: 'clicks', 'text': '点击量' },
    { id: 'ctr', 'text': 'CTR' },
    { id: 'cpc', 'text': 'CPC' },
    { id: 'cost', 'text': '花费' },
    { id: 'adsOrders', 'text': '广告总订单量' },
    { id: 'adsSales', 'text': '广告总销售额' },
    { id: 'acos', 'text': 'ACOS' },
    { id: 'cpa', 'text': 'CPA' },
    { id: 'roas', 'text': 'ROAS' },
];

//
export const AD_TYPE_OPTIONS = [
    { id: 'adsCampaign', text: '按广告活动' },
    { id: 'adsGroup', text: '按广告组' },
];


export const DATE_OPTIONS =  [
    {id: 'HOURS', text: '按时'},
    {id: 'DAY', text: '按日'},
    {id: 'WEEK', text: '按周'},
    {id: 'MONTH', text: '按月'},
];

export const STATUS_OPTIONS = [
    { id: 'Pending', text: '待处理' },
    { id: 'Processing', text: '处理中' },
    { id: 'Done', text: '已处理' },
]

export const ASIN_OPTIONS = [
    { id: 'child', text: '子ASIN' },
    { id: 'parent', text: '父ASIN' },
]

export const GROUP_OPTIONS = [
    { id: 'MARKET', text: '按站点' },
    { id: 'AREA', text: '按地区' },
]

export const RETURN_REASON_OPTIONS = [
    {id: 'OTHER', text: 'OTHER'},
    {id: 'ORDERED_WRONG_ITEM', text: 'ORDERED_WRONG_ITEM'},
    {id: 'FOUND_BETTER_PRICE', text: 'FOUND_BETTER_PRICE'},
    {id: 'NO_REASON_GIVEN', text: 'NO_REASON_GIVEN'},
    {id: 'QUALITY_UNACCEPTABLE', text: 'QUALITY_UNACCEPTABLE'},
    {id: 'NOT_COMPATIBLE', text: 'NOT_COMPATIBLE'},
    {id: 'DAMAGED_BY_FC', text: 'DAMAGED_BY_FC'},
    {id: 'MISSED_ESTIMATED_DELIVERY', text: 'MISSED_ESTIMATED_DELIVERY'},
    {id: 'MISSING_PARTS', text: 'MISSING_PARTS'},
    {id: 'DAMAGED_BY_CARRIER', text: 'DAMAGED_BY_CARRIER'},
    {id: 'SWITCHEROO', text: 'SWITCHEROO'},
    {id: 'DEFECTIVE', text: 'DEFECTIVE'},
    {id: 'EXTRA_ITEM', text: 'EXTRA_ITEM'},
    {id: 'UNWANTED_ITEM', text: 'UNWANTED_ITEM'},
    {id: 'WARRANTY', text: 'WARRANTY'},
    {id: 'UNAUTHORIZED_PURCHASE', text: 'UNAUTHORIZED_PURCHASE'},
    {id: 'UNDELIVERABLE_INSUFFICIENT_ADDRESS', text: 'UNDELIVERABLE_INSUFFICIENT_ADDRESS'},
    {id: 'UNDELIVERABLE_FAILED_DELIVERY_ATTEMPTS', text: 'UNDELIVERABLE_FAILED_DELIVERY_ATTEMPTS'},
    {id: 'UNDELIVERABLE_REFUSED', text: 'UNDELIVERABLE_REFUSED'},
    {id: 'UNDELIVERABLE_UNKNOWN', text: 'UNDELIVERABLE_UNKNOWN'},
    {id: 'UNDELIVERABLE_UNCLAIMED', text: 'UNDELIVERABLE_UNCLAIMED'},
    {id: 'APPAREL_TOO_SMALL', text: 'APPAREL_TOO_SMALL'},
    {id: 'APPAREL_TOO_LARGE', text: 'APPAREL_TOO_LARGE'},
    {id: 'APPAREL_STYLE', text: 'APPAREL_STYLE'},
    {id: 'MISORDERED', text: 'MISORDERED'},
    {id: 'NOT_AS_DESCRIBED', text: 'NOT_AS_DESCRIBED'},
    {id: 'JEWELRY_TOO_SMALL', text: 'JEWELRY_TOO_SMALL'},
    {id: 'JEWELRY_TOO_LARGE', text: 'JEWELRY_TOO_LARGE'},
    {id: 'JEWELRY_BATTERY', text: 'JEWELRY_BATTERY'},
    {id: 'JEWELRY_NO_DOCS', text: 'JEWELRY_NO_DOCS'},
    {id: 'JEWELRY_BAD_CLASP', text: 'JEWELRY_BAD_CLASP'},
    {id: 'JEWELRY_LOOSE_STONE', text: 'JEWELRY_LOOSE_STONE'},
    {id: 'JEWELRY_NO_CERT', text: 'JEWELRY_NO_CERT'}
]

export const REMOVAL_OPTIONS = [
    {id: 'Return', text: 'Return'},
    {id: 'Disposal', text: 'Disposal'},
    {id: 'Donate', text: 'Donate'},
    {id: 'Liquidations', text: 'Liquidations'}
]


// 发送时间
export const SEND_TIME_WAY = [
    {id: 'Purchase', text: '订单订购后'},
    {id: 'Shipped', text: '订单发货后'}, 
    {id: 'Delivery', text: '订单送达后'}
]

// 纸张类型
export const PaperLabel = [
    { id: 11, text: '热敏纸（50*30）单排', width: 50, height: 30, pageWidth: 50, pageHeight: 30 },
    { id: 12, text: '热敏纸（100*30）双排', width: 50, height: 30, pageWidth: 100, pageHeight: 30 },
    { id: 0, text: '每张US信纸最多30个标签（1英寸x2-5/8英寸）', width: 25.4, height: 11, pageWidth: 215.9, pageHeight: 279.4, widthCount: 5, heightCount: 6, count: 30 },
    { id: 1, text: '每页纸最多 21 个标签（A4 纸，63.5 毫米 x 38.1 毫米）', width: 63.5, height: 38.1, pageWidth: 210, pageHeight: 297, widthCount: 3, heightCount: 7, count: 21, havePadding: true, paddingTop: 15, paddingLeft: 7, interval: 3 },
    { id: 2, text: '每页纸最多 24 个标签（A4 纸，63.5 毫米 x 33.9 毫米)', width: 63.5, height: 33.9, pageWidth: 210, pageHeight: 297, widthCount: 3, heightCount: 8, count: 24 },
    { id: 3, text: '每页纸最多 24 个标签（A4 纸，64.6 毫米 x 33.8 毫米）', width: 64.6, height: 33.8, pageWidth: 210, pageHeight: 297, widthCount: 3, heightCount: 8, count: 24 },
    { id: 4, text: '每页纸最多 24 个标签（A4 纸，66 毫米 x 33.9 毫米）', width: 66, height: 33.9, pageWidth: 210, pageHeight: 297, widthCount: 3, heightCount: 8, count: 24 },
    { id: 5, text: '每页纸最多 24 个标签（A4 纸，66 毫米 x 35 毫米）', width: 66, height: 35, pageWidth: 210, pageHeight: 297, widthCount: 3, heightCount: 8, count: 24 },
    { id: 6, text: '每页纸最多 24 个标签（A4 纸，70 毫米 x 36 毫米）', width: 70, height: 36, pageWidth: 210, pageHeight: 297, widthCount: 3, heightCount: 8, count: 24 },
    { id: 7, text: '每页纸最多 24 个标签（A4 纸，70 毫米 x 37 毫米）', width: 70, height: 37, pageWidth: 210, pageHeight: 297, widthCount: 3, heightCount: 8, count: 24 },
    { id: 8, text: '每页纸最多 27 个标签（A4 纸，63.5 毫米 x 29.6 毫米）', width: 63.5, height: 29.6, pageWidth: 210, pageHeight: 297, widthCount: 3, heightCount: 9, count: 27 },
    { id: 9, text: '每页纸最多 40 个标签（A4 纸，52.5 毫米 x 29.7 毫米）', width: 52.5, height: 29.7, pageWidth: 210, pageHeight: 297, widthCount: 4, heightCount: 10, count: 40 },
    { id: 10, text: '每页纸最多 44 个标签（A4 纸，48.5 毫米 x 25.4 毫米）', width: 48.5, height: 25.4, pageWidth: 210, pageHeight: 297, widthCount: 4, heightCount: 11, count: 44, havePadding: true, paddingTop: 10, paddingLeft: 8 },
];

export const BarcodeEncodeingOptoins = [
    { id: 'CODE128A', text: 'CODE128A', jsCode: 'CODE128A', printCode: '128A' },
    { id: 'CODE128B', text: 'CODE128B', jsCode: 'CODE128B', printCode: '128B' }
];

/**
 * 打印单双排option
 */
export const PaperLabelColumnOption = [
    { id: 1, text: 'WAREHOUSE.singleRow' },
    { id: 2, text: 'WAREHOUSE.doubleRow' },
];

export const currencyMarketOption = [
    { id: 1, text: 'US', eText: '1', icon: 'icon-meiguo-', currency: '$' },
    { id: 8, text: 'CA', eText: '8', icon: 'icon-jianada-', currency: 'CA$' },
    { id: 9, text: 'MX', eText: '9', icon: 'icon-moxige', currency: 'MX$' },
    { id: 3, text: 'UK', eText: '3', icon: 'icon-yingguo-', currency: '￡' },
    { id: 4, text: 'DE', eText: '4', icon: 'icon-deguo1', currency: '€' },
    { id: 5, text: 'FR', eText: '5', icon: 'icon-faguoqi', currency: '€' },
    { id: 6, text: 'ES', eText: '6', icon: 'icon-xiaoshou-', currency: '€' },
    { id: 7, text: 'IT', eText: '7', icon: 'icon-yidali', currency: '€' },
    { id: 2, text: 'JP', eText: '2', icon: 'icon-riben', currency: 'J￥' },
    { id: 10, text: 'AU', eText: '10', icon: 'icon-aodaliya-', currency: 'AU$' },
    { id: 11, text: 'IN', eText: '11', icon: 'icon-yindu', currency: '₹' },
    { id: 13, text: 'AE', eText: '13', icon: 'icon-alabolianheqiuchangguo', currency: 'د.إ' },
    { id: 14, text: 'SG', eText: '14', icon: 'icon-icon_SGxinjiapo', currency: 'S$' },
    { id: 15, text: 'NL', eText: '15', icon: 'icon-helan', currency: '€' },
    { id: 16, text: 'SA', eText: '16', icon: 'icon-shatealabo', currency: 'ريال' },
    { id: 17, text: 'BR', eText: '17', icon: 'icon-baxi', currency: 'R€' },
    { id: 18, text: 'SE', eText: '18', icon: 'icon-ruidian', currency: 'kr' },
    { id: 19, text: 'TR', eText: '19', icon: 'icon-tuerqi', currency: '₺' },
    { id: 20, text: 'PL', eText: '20', icon: 'icon-bolan', currency: 'zł' },
];

// 扣减状态
export const consumeStatusOption = [
    { id: 'Normal', text: '正常', ...tagColors.greenText },
    { id: 'Abnormal', text: '异常', ...tagColors.redText }
]
